var _path, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _polygon2, _path8, _polygon3, _circle, _polygon4, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _polygon5, _path18, _polygon6, _path19, _path20, _path21, _path22, _path23, _path24, _circle2, _path25, _path26, _polygon7, _path27, _polygon8, _path28, _path29, _path30, _circle3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _polygon9, _path40, _polygon10, _path41, _path42, _path43, _path44, _path45, _circle4, _path46;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 766.80194,
    height: 500.94794,
    viewBox: "0 0 766.80194 500.94794",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ae90ee98-50a6-4343-bcab-c7717b4ab754-727",
    "data-name": "Path 133",
    d: "M880.50872,613.59857a158.39405,158.39405,0,0,1-7.4,43.785c-.1.329-.211.653-.319.982h-27.613c.029-.295.059-.624.088-.982,1.841-21.166-8.677-148.453-21.369-170.483C825.00771,488.68756,882.64971,546.34454,880.50872,613.59857Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "ace95f5d-9239-4670-9a5e-89bd21d3a3cd-728",
    "data-name": "Path 134",
    d: "M878.43667,657.38354c-.231.329-.471.658-.717.982h-20.716c.157-.28.339-.609.55-.982,3.422-6.176,13.551-24.642,22.953-43.785,10.1-20.572,19.374-41.924,18.593-49.652C899.34167,565.68853,906.33364,618.82256,878.43667,657.38354Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "b1e24b1a-80e9-492b-ae8f-155b8492cb31-729",
    "data-name": "Path 133",
    d: "M947.93193,633.82353a86.83454,86.83454,0,0,1-4.0568,24.00366c-.05483.18035-.11568.358-.17488.53834H928.56233c.0159-.16171.03234-.3421.04825-.53834,1.00927-11.60357-4.75688-81.38443-11.71483-93.46166C917.50535,565.34522,949.10565,596.95375,947.93193,633.82353Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "b092796d-fbce-4787-85db-a435af6317d1-730",
    "data-name": "Path 134",
    d: "M946.796,657.82719c-.12663.18035-.25821.36074-.39307.53834H935.04606c.08607-.15351.18584-.33387.30151-.53834,1.876-3.3858,7.42888-13.50918,12.58322-24.00366,5.537-11.27792,10.62115-22.98344,10.193-27.22C958.25646,607.55845,962.08958,636.68742,946.796,657.82719Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "f749498b-12ad-4a63-9639-cd9a5a319912-731",
    "data-name": "Path 133",
    d: "M804.93193,633.82353a86.83454,86.83454,0,0,1-4.0568,24.00366c-.05483.18035-.11568.358-.17488.53834H785.56233c.0159-.16171.03234-.3421.04825-.53834,1.00927-11.60357-4.75688-81.38443-11.71483-93.46166C774.50535,565.34522,806.10565,596.95375,804.93193,633.82353Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a1477d31-24e2-4198-a2a2-41d3c8f4997f-732",
    "data-name": "Path 134",
    d: "M803.796,657.82719c-.12663.18035-.25821.36074-.39307.53834H792.04606c.08607-.15351.18584-.33387.30151-.53834,1.876-3.3858,7.42888-13.50918,12.58322-24.00366,5.537-11.27792,10.62115-22.98344,10.193-27.22C815.25646,607.55845,819.08958,636.68742,803.796,657.82719Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#f0f0f0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "314.574 442.1 329.13 442.1 336.055 385.955 314.572 385.956 314.574 442.1",
    fill: "#ffb7b7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M527.87085,638.71326l28.66618-.00116h.00116a18.26932,18.26932,0,0,1,18.26834,18.26805v.59365l-46.93482.00174Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "235.763 442.1 250.319 442.1 257.243 385.955 235.76 385.956 235.763 442.1",
    fill: "#ffb7b7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M449.05923,638.71326l28.66618-.00116h.00116a18.26932,18.26932,0,0,1,18.26834,18.26805v.59365l-46.93481.00174Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "229.832 187.638 229.832 335.879 233.585 431.579 264.547 431.579 274.867 251.438 295.508 325.559 308.644 429.702 346.173 427.826 320.841 187.638 229.832 187.638",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 265.82446,
    cy: 31.89109,
    r: 22.51761,
    fill: "#ffb8b8"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "256.468 60.275 250.473 66.606 244.844 193.268 311.458 191.391 295.508 80.68 281.435 67.193 274.294 60.275 256.468 60.275",
    fill: "#2bcbba"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M462.79141,275.47713l5.0565-8.20674,1.51113,17.58907s12.197,39.40581,11.25881,74.12045,4.69116,116.34093-2.8147,117.27917-39.40581,2.8147-39.40581-3.75294-1.87647-181.07907-1.87647-181.07907Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#3f3d56"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M496.93315,267.27039l12.76994,10.0832,28.147,10.32057s0,120.09387,5.6294,148.24087,15.95,30.96171,2.81471,31.89994-12.197-3.75293-12.197-3.75293,9.38233-46.91168-2.8147-56.294-35.65288-63.79988-33.77641-93.82336S495.05668,267.27039,496.93315,267.27039Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M461.53113,240.30161s1.91318-3.35983,1.4684-14.5839,16.6468-4.87588,30.92861-5.9466S505.18674,238.51,505.18674,238.51s1.03034-1.17758,3.2363-10.73827-2.80275-19.0883-2.80275-19.0883c-1.47514-10.0465-9.42511-6.82659-9.42511-6.82659,3.82861,1.49044,3.09328,4.67734,3.09328,4.67734-3.24078-5.682-11.19076-2.46206-11.19076-2.46206-10.603-6.65362-21.349,2.10836-21.349,2.10836-12.80892,2.907-5.297,13.09344-5.297,13.09344C448.57021,225.78368,461.53113,240.30161,461.53113,240.30161Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M438.42881,458.93962a9.49863,9.49863,0,0,0-1.68433-14.46727l4.05627-21.32359-12.35709-5.62547-5.30529,30.19349a9.55009,9.55009,0,0,0,15.29044,11.22284Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#ffb7b7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M441.212,291.4271l-2.49124-1.33569S425.26207,295.18,426.2003,298.933s-7.50587,135.10561-4.69117,139.79677,25.33231.93824,25.33231.93824Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#3f3d56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M548.31956,450.09621A9.49861,9.49861,0,0,1,547.986,435.535l-6.96762-20.55726,11.45989-7.28112,9.43188,29.169a9.55009,9.55009,0,0,1-13.59056,13.23051Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#ffb7b7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M537.32138,432.1739s22.82029.60126,24.95884-4.43423-24.39848-133.95644-23.98853-137.8031-13.62341-7.02415-13.62341-7.02415l-2.28247,1.66752Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M638.18107,437.97478l-14.12821-69.2292L617.84655,317.613,604.097,326.50775l1.89939,56.34823L627.942,441.23817a7.64968,7.64968,0,1,0,10.23905-3.26339Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#ffb7b7"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M506.04064,443.3277l3.91075-70.54781-1.29534-51.4916,18.17731,6.80078,3.03452,56.02546-13.22247,60.95292a7.64968,7.64968,0,1,1-10.60477-1.73975Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#ffb7b7"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.101 447.07 336.389 447.07 340.808 411.244 327.1 411.245 327.101 447.07",
    fill: "#ffb7b7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M541.7415,645.40318l18.29158-.00074h.00074a11.65746,11.65746,0,0,1,11.65683,11.65664v.3788l-29.9486.00111Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "362.281 442.96 371.46 444.38 381.305 409.651 367.757 407.556 362.281 442.96",
    fill: "#ffb7b7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M577.41309,640.96639l18.0766,2.79617.00073.00011a11.65745,11.65745,0,0,1,9.73738,13.302l-.05792.37435-29.59659-4.57823Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M541.38251,637.739l-.04814-.25982L507.71,455.68343a68.67452,68.67452,0,0,1,6.06847-42.94446l20.35148-40.70268,60.72681,8.22705,7.16679,51.821,25.53977,98.85618-.02529.08047L594.81606,634.96145l-21.4455,1.4106,18.99678-92.78153L557.58325,464.585l2.45346,171.74047Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M596.27034,386.89527l-.40079-.628c-.072-.11324-7.44846-11.22672-27.52144-3.80643-20.49131,7.57635-36.369-7.05672-36.52708-7.20531l-.0786-.07415-4.64063-41.362-5.47828-33.57784,17.43861-3.05945,8.57351-5.14374,34.09245-.607,8.97143,7.05614,14.72935,1.60518,1.34838,30.59541-.00618.03334Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M601.15642,333.64753V307.44946l4.142-7.55911.16842-.00517a12.41671,12.41671,0,0,1,8.57883,3.89782c4.16612,4.23294,6.05339,11.28535,5.60948,20.96122l-.00819.177Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M528.9619,330.7999l-21.111-2.5335-.01652-.24315c-.72025-10.52745,1.1173-18.34207,5.46146-23.22627a13.39066,13.39066,0,0,1,8.65069-4.71033l.12186-.00575,5.71481,5.19518Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M590.07389,280.87513H534.52208a4.31491,4.31491,0,0,1-4.31-4.31006V256.45149a32.086,32.086,0,1,1,64.17191,0v20.11358A4.31491,4.31491,0,0,1,590.07389,280.87513Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 346.578,
    cy: 55.78733,
    r: 23.5243,
    fill: "#ffb7b7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M585.94786,257.88817H554.89008a2.39792,2.39792,0,0,1-2.376-2.098l-.4022-3.21664a1.43658,1.43658,0,0,0-2.72745-.42932l-2.036,4.36243a2.40372,2.40372,0,0,1-2.16976,1.3815H540.461a2.394,2.394,0,0,1-2.38371-2.62269l1.86016-19.42985a2.41285,2.41285,0,0,1,1.3684-1.95019c14.22351-6.64,28.64717-6.63157,42.87068.02525a2.398,2.398,0,0,1,1.35484,1.838l2.78662,19.4046a2.3938,2.3938,0,0,1-2.37016,2.73493Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M598.72673,440.175a8.59205,8.59205,0,0,0,4.60352-12.34441l20.135-22.95337-15.71777-2.16839-16.71083,22.12936a8.63859,8.63859,0,0,0,7.69009,15.33681Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#9f616a"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "406 442.234 391.957 442.233 385.276 388.067 406.003 388.068 406 442.234",
    fill: "#9f616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M626.591,657.21212l-45.28071-.00167v-.57273a17.62547,17.62547,0,0,1,17.62451-17.62424h.00112l27.65592.00112Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "479.511 430.482 466.099 434.646 443.656 384.897 463.451 378.752 479.511 430.482",
    fill: "#9f616a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M703.97745,643.786,660.733,657.21212l-.16984-.547a17.62544,17.62544,0,0,1,11.60538-22.05793l.00107-.00034,26.41225-8.20014Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "f1066638-9b86-4717-bcc8-db5f2da468bd-733",
    "data-name": "Path 973",
    d: "M612.25556,393.87135l-20.798,23.81941,16.28228,1.46511Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#e6e6e6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "af262a15-c86f-47ab-a56c-b4ab6ae66702-734",
    "data-name": "Path 975",
    d: "M604.129,424.57384s-7.22426,3.6117-8.1274,19.86651S598.711,503.1402,598.711,503.1402s-3.6117,18.96341,0,36.12048-3.6117,79.46267.90315,79.46267,27.99307,2.70944,28.89621,0,1.8063-43.34475,1.8063-43.34475,7.22425-20.76965,0-33.40848c0,0,25.22372,44.0448,41.53849,77.659,3.57061,7.35673,30.70248-.90314,26.18763-9.03052s-15.35082-45.151-15.35082-45.151-8.1274-27.09078-22.57508-38.82991l7.22426-57.79327s15.35165-38.82991,6.32283-44.2479S604.129,424.57384,604.129,424.57384Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "fbcb1e7b-18f5-4394-a5dd-21324d3d96d7",
    "data-name": "Ellipse 182",
    cx: 414.20933,
    cy: 52.53703,
    r: 23.47823,
    fill: "#a0616a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "f91d5893-36b1-4b4e-ad68-e940b5b31ca4-735",
    "data-name": "Path 976",
    d: "M657.4066,279.18705,628.219,296.34414s-11.176,6.29379-15.35082,17.15709c-4.44992,11.57762-1.86353,27.87858,0,31.60563,3.6117,7.22426-1.51493,25.28452-1.51493,25.28452l-4.51484,41.53847s-16.254,15.3508-3.6117,17.15709,35.21735-.90315,48.76275,0,28.89619,2.70944,24.38134-6.32283S666.438,407.41242,671.856,389.3556c4.2397-14.1324,4.056-66.97336,3.77576-89.2887a17.96455,17.96455,0,0,0-8.72465-15.18079Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#e5e5e5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ab5b7163-34aa-4542-8f5b-346ef47d8115-736",
    "data-name": "Path 980",
    d: "M644.31661,307.633l2.70857,55.08386-26.25344,53.16567-4.45248-1.69435,27.09079-49.66586Z",
    transform: "translate(-217.00961 -201.36553)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a0747de6-ab5b-4f6b-918c-fa029658d911-737",
    "data-name": "Path 982",
    d: "M674.11256,374.45511v-6.32283L643.41348,418.703Z",
    transform: "translate(-217.00961 -201.36553)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "fa11fa6f-8d0b-4738-bd9e-1b384a1b66c7-738",
    "data-name": "Path 983",
    d: "M614.55571,232.15286l-3.87829-1.55167s8.11715-8.93485,19.40684-8.15817l-3.17595-3.49637s7.76256-3.10758,14.82022,5.04973c3.71,4.28843,8.00179,9.32961,10.68046,15.00733h4.15683l-1.7345,3.8202,6.07162,3.8202-6.23227-.68354a21.13815,21.13815,0,0,1-.58957,9.89354l.1709,3.01958s-7.22767-11.18375-7.22767-12.73542v3.88513s-3.88171-3.49637-3.88171-5.82727l-2.11729,2.71968-1.05866-4.27218-13.0558,4.27218,2.11559-3.49806-8.11715,1.16547,3.17595-4.27219s-9.17409,5.04973-9.527,9.32361-4.93951,9.71153-4.93951,9.71153l-2.11729-3.88512S604.32637,237.9801,614.55571,232.15286Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M629.74558,442.7301a8.592,8.592,0,0,0,2.33926-12.96552l15.741-26.16289-15.85307.656-12.51746,24.74416a8.63859,8.63859,0,0,0,10.29029,13.72826Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#9f616a"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "b6ea18e9-d072-4df0-8b87-7f4e4805b6d9-739",
    "data-name": "Path 981",
    d: "M665.53487,290.92788l6.77226-1.35428s20.31769,14.89967,13.99655,44.699S651.98947,409.223,651.98947,409.223s-6.32283,8.1274-8.1274,9.93284-5.418,0-3.6117,2.70941-2.70941,4.51484-2.70941,4.51484-19.86653,0-18.06024-7.22425S651.9895,360.456,651.9895,360.456l-4.51484-47.8596S643.86121,289.12161,665.53487,290.92788Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#e5e5e5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M982.81154,659.36553h-611a1,1,0,1,1,0-2h611a1,1,0,1,1,0,2Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#cacaca"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.11656,243.13545v.34417H223.688a5.457,5.457,0,0,0-5.457,5.457v19.9756a5.457,5.457,0,0,0,5.457,5.457h51.7256a5.457,5.457,0,0,0,5.457-5.457V248.93661a5.457,5.457,0,0,0-5.457-5.457h-35.5857v-.34417Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#3f3d56"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M370.21772,326.10326c.219,29.48-18.61722,25.02175-41.58273,25.02175s-39.58048,4.391-41.58274-25.02175c-3.18165-46.73773,9.094-81.73773,41.58274-81.73773C362.243,244.36553,369.8706,279.36553,370.21772,326.10326Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M244.44075,263.57394a11.45606,11.45606,0,0,1-7.07667,16.078L235.26856,320.309l-17.03821-12.54026,4.60208-36.68608a11.51816,11.51816,0,0,1,21.60832-7.50876Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#a0616a"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M398.08363,493.34215a11.45606,11.45606,0,0,0-5.00417-16.83867L396.1,435.90466l-18.47655,10.30417-.03567,36.97359a11.51816,11.51816,0,0,0,20.49588,10.15973Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#a0616a"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "95.985 487.409 109.952 487.408 116.596 433.535 95.982 433.536 95.985 487.409",
    fill: "#a0616a"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M309.43154,684.21448l27.50589-.00111h.00111a17.52859,17.52859,0,0,1,17.52909,17.52881v.56962l-45.03526.00167Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "184.846 487.409 198.813 487.408 205.458 433.535 184.844 433.536 184.846 487.409",
    fill: "#a0616a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M398.29327,684.21448l27.50589-.00111h.00112a17.52859,17.52859,0,0,1,17.52908,17.52881v.56962l-45.03526.00167Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M393.884,470.97338l-.6069-.11014c-5.08742-.92119-10.23658-1.8524-14.76384-2.82588l-.44808-.09679-.00166-.45838c-.0776-20.65007-.15548-41.2968-.2698-62.13045a131.32591,131.32591,0,0,1-13.13061-70.39337l.02559-.25589.21-.15019a13.50463,13.50463,0,0,1,13.60985-1.05248,15.08909,15.08909,0,0,1,7.74586,11.45483c4.117,22.438,8.37918,45.67359,13.13284,68.56991l.01752.08344-.00806.08566c-1.76117,18.67307-3.58214,37.98252-5.45123,56.6656Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M384.7789,669.57388l-.111-.52512c-6.534-30.90669-12.84135-56.07484-18.94119-80.41413-7.30975-29.16888-14.23677-56.80912-21.23-92.57766.96041,45.10619,3.19107,77.5126,5.75523,114.76194,1.15789,16.81956,2.355,34.21208,3.56962,54.51615l.03727.61969-.62025-.01558c-21.85941-.55961-44.25536-1.91025-65.91424-3.21527l-.573-.03449.03894-.573c4.10058-60.4416,5.38558-99.7169,6.32374-128.39515,1.97951-60.5039,2.28379-69.80372,24.82131-121.00892.85416-1.94251,5.951-7.68217,11.55468-6.8077l44.34214,6.90116.0776.3905c1.25162,6.30261,7.46078,25.42737,16.05468,51.89721C408.33607,521.679,436.09924,607.192,444.77242,658.16466l.09818.57742-.57964.08233c-12.59742,1.79009-21.66389,3.65473-30.43191,5.45706-8.29574,1.70666-16.87351,3.47005-28.54974,5.21231Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M346.23983,428.801c-11.835.00112-23.533-4.10531-31.91883-12.10122a9.46491,9.46491,0,0,1-4.66938-7.35619,9.5971,9.5971,0,0,1,2.2543-7.78675c-8.22175-9.95178-16.71052-20.23732-24.83632-30.71088l-.22446-.28926.26006-.4962c5.31633-10.1576,10.81372-20.66009,16.09306-31.038a5.42314,5.42314,0,0,1,4.42239-3.34878,6.305,6.305,0,0,1,4.86881,1.08807l.01057-.25255c.22056-5.25346.4414-10.50693.66808-15.48672l.0242-.5318.53236-.01223c10.15092-.22363,20.64729-.45615,30.95758-1.06694l.39246-.02336,5.11356,11.407A41.825,41.825,0,0,1,374.1849,335.666l.33766.18023-.03922.3805a232.24542,232.24542,0,0,0,1.33117,58.8818c-.15965,8.8993-.33126,17.99552-2.13693,25.246l-.05257.21139-.18079.12238A48.64723,48.64723,0,0,1,346.23983,428.801Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M302.67675,379.31247l-.68116-.31263c-7.95224-3.98961-15.92951-8.41534-23.644-12.69533l-1.06582-.208c-20.31214-4.07751-31.50107-6.32264-49.82619-17.06877l-.14074-.08344-.07565-.14464c-9.17577-17.52825-11.7352-32.85031-9.44362-56.53209l.04589-.47506.47506-.03782c1.98647-.16132,5.22427-.26924,8.35527-.37382,3.04616-.10124,6.19608-.20694,8.12719-.35824l.44808-.03561.13851.42722c2.40117,7.41516,4.441,14.333,6.60077,21.65694,2.21982,7.52863,4.51418,15.30982,7.30891,23.95546,10.23242,2.94048,37.66321,2.06156,46.19231.90006a15.26092,15.26092,0,0,1,13.32559,6.05895l.15826.198-.04088.25032c-1.87771,11.45928-4.03384,22.98643-6.11876,34.1342Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2bcbba"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 328.12367,
    cy: 288.18638,
    r: 27.98122,
    transform: "translate(-299.14414 236.50296) rotate(-61.33681)",
    fill: "#a0616a"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M296.16628,286.51786v0h11.0671l4.88244-13.671.97626,13.671h5.28963l2.84813-7.97477.56963,7.97477H361.1037v0a29.62055,29.62055,0,0,0-29.62055-29.62054h-5.69633A29.62054,29.62054,0,0,0,296.16628,286.51786Z",
    transform: "translate(-217.00961 -201.36553)",
    fill: "#2f2e41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.868609052ddfde59c7cff4d5fb759537.svg";
export { ForwardRef as ReactComponent };